(function ($) {
  const isPageEditor = function () {
    return !!(typeof Sitecore !== 'undefined' && Sitecore.PageModes && Sitecore.PageModes.PageEditor);
  };

  const init = function () {
    let toggle = $('.navbar-toggle');
    let mainMenu = $('.main-menu .navbar-collapse');
    let countryMenu = $('.mobile-nav #countryDropdown');
    let subMenu = $('.country-dropdown');
    let dropdownLink = $('.nav-container .dropdown-toggle');
    let desktopAccount = $('.desktop-nav .my-account');
    let mobileNav = $('.mobile-nav .main-nav');
    let backBtn = $('mobile-nav .backcta');
    
    $(backBtn).on('click', function () {
      $(this).parent('.dropdown-menu').removeClass('show');
    });

    $(desktopAccount).mouseenter(function () {
      $(this).find('.dropdown-menu').addClass('show');
    });

    $(desktopAccount).mouseleave(function () {
      $(this).find('.dropdown-menu').removeClass('show');
    });

    $(toggle).on('click', function () {
      if ($(this).hasClass('collapsed')) {
        $(this).removeClass('collapsed');
        showMenu();
      } else {
        $(this).addClass('collapsed');
        hideMenu();
      }
    });

    function showMenu() {
      $(mainMenu).addClass('show');

      if ($(window).width() < 836) {
        $(mobileNav).css('height', 'calc(100vh - 58px)');
      }
    }

    function hideMenu() {
      $(mainMenu).removeClass('show');

      if ($(window).width() < 836) {
        $(mobileNav).css('height', 'unset');
      }
    }

    $(countryMenu).on('click', () => {
      $(subMenu).toggleClass('show');
    });
  };

  var logoutDestination = (logoutDestinationUrl === undefined) ? '' : logoutDestinationUrl;
  var logoutUrl = (logoutUrl === undefined) ? '' : logoutUrl;
  
  if (!isPageEditor()) {
    attachLogout(logoutDestination, logoutUrl);
  }
  // if (commercialAccount == 'true') {
  //   $(a[href^='/orders']).parent('li').hide;
  // }
  $(init);
}(jQuery));

function attachLogout(redirectUrl, logoutUrl) {
  $('.logout').on('click', (e) => {
    e.preventDefault();
    logout(redirectUrl, logoutUrl);
  });
}

function logout(redirectUrl, logoutUrl) {
  if (!redirectUrl) {
    redirectUrl = '/';
  }

  if (!logoutUrl) {
    logoutUrl = '/api/sitecore/SspNavigation/DoLogout';
  }

  $.ajax({
    url: logoutUrl,
    type: 'GET',
    contentType: 'application/json',
    success(result) {
      if (result.ErrorMessage) {
        // TODO: What should we do here?
        alert(result.ErrorMessage);
      } else {
        window.location.href = redirectUrl;
      }
    },
  });
}
